import React, {ReactNode} from "react";
import styles from "./Button.module.css";
import clsx from "clsx";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    color: "white" | "green";
    children?: string;
    isActive?: boolean;
    icon?: ReactNode;
    fontSize?: number;
    fullWidth?: boolean;
}

function Button(props: ButtonProps) {
    const {color, children, icon, isActive, fontSize = 16, fullWidth, ...buttonProps} = props;
    const classes = clsx(styles.button, {
        [styles.buttonActive]: isActive,
        [styles.fullWidth]: fullWidth,
        [styles.buttonWhite]: color === "white",
        [styles.buttonGreen]: color === "green"
    });

    return (
        <button className={classes} {...buttonProps}>
            <div className={styles.content}>
                {
                    icon &&
                    <div className={children === "Professional" ? styles.iconLongStr : styles.icon}>{icon}</div>
                }

                {
                    children &&
                    <div className={styles.label} style={{fontSize}}>
                        {children}
                    </div>
                }
            </div>
        </button>
    );
}

export default Button;
